import styles from './Widgets.module.css'

export function StatGrid({ items, label }) {
  return (
    <dl className={styles.statGrid} aria-label={label}>
      {items.map((item) => (
        <div key={item.label} className={styles.stat}>
          <dt className={styles.statLabel}>{item.label}</dt>
          <dd className={styles.statValue}>{item.value}</dd>
          {item.note ? <dd className={styles.statNote}>{item.note}</dd> : null}
        </div>
      ))}
    </dl>
  )
}

export function Segmented({ items, value, onChange, label }) {
  return (
    <div className={styles.segmented} role="group" aria-label={label}>
      {items.map((item) => (
        <button key={item.value} type="button" className={styles.segment} aria-pressed={item.value === value} onClick={() => onChange(item.value)}>
          {item.label}
        </button>
      ))}
    </div>
  )
}
